import { apiSlice } from '@services/apiSlice';
import { Stories as endpoints } from '@services/endpoints';
import { StoriesPage, StoriesListResponse, StoriesList } from './Stories.types';

interface StoriesQueryParams {
  page: number;
  country: number;
  industry: number;
  subIndustry: number;
}

const storiesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchStoriesPageData: build.query<StoriesPage, void>({
      query: () => ({
        url: endpoints.fetchStories,
        params: { language: window.lang, pageId: window.pageId },
      }),
    }),
    fetchStories: build.query<StoriesList, StoriesQueryParams>({
      query: (params) => ({
        url: endpoints.fetchStories,
        params: { language: window.lang, pageId: window.pageId, ...params },
      }),
      transformResponse: (response: StoriesListResponse) => {
        return {
          StoriesListItems: response.storiesListItems,
          HasNextPage: response.HasNextPage,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useLazyFetchStoriesQuery, useFetchStoriesPageDataQuery } = storiesApi;
